<template>
  <div class="inline-flex font-bold overflow-hidden" :style="{ fontSize: `${size}px` }">
    <div
      v-for="(digit, index) in formattedNumber"
      :key="index"
      class="transition-transform duration-500"
      :style="digitStyle(digit)"
    >
      <div class="w-fit">,</div>
      <div class="w-fit">.</div>
      <div v-for="number in digitsAmount" :key="number">
        {{ digitsAmount - number }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberCounter',
  props: {
    number: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 16,
    },
    punctuation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      digitsAmount: 10,
    };
  },
  computed: {
    formattedNumber() {
      return this.punctuation
        ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(this.number)
        : this.number.toString();
    },
    digitHeight() {
      return this.size * 1.5;
    },
    digitsVerticalPosition() {
      return Array.from({ length: this.digitsAmount + 2 }, (_, index) => `${((this.digitsAmount + 1) - index) * -this.digitHeight}px`);
    },
  },
  methods: {
    getDigitIndex(digit) {
      if (digit === '.') return 10;
      if (digit === ',') return 11;
      return parseInt(digit, 10);
    },
    isPunctuation(digit) {
      return digit === '.' || digit === ',';
    },
    digitStyle(digit) {
      const isPunctuation = this.isPunctuation(digit);
      return {
        height: `${this.digitHeight}px`,
        lineHeight: `${this.digitHeight}px`,
        width: isPunctuation ? `${this.digitHeight / 4}px` : 'initial',
        transform: `translateY(${this.digitsVerticalPosition[this.getDigitIndex(digit)]})`,
      };
    },
  },
};
</script>
